import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const maleActivity: AppAreaConfig = {
	appArea: 'activity-male',
	options: {
		userTags: ['activity'],
	},
	landing: {
		ids: ['loader-activity-m', 'age-activity-m'],
		route: {
			path: '/activity-m',
			name: 'male-activity-funnel',
		},
	},
	funnel: {
		id: 'ob-male-activity',
		route: {
			path: '/activity-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-activity-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'male-activity',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-activity-m',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-activity-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
}

export default maleActivity
